import { createSelector } from '@reduxjs/toolkit'
import { getDownloadSelectors, getSelectors } from '@repo/core'
import { selectorsConfig } from './selectors.const'

export const globalPositionDownloadSelector = getDownloadSelectors({
  getRootPath: selectorsConfig.globalPositionDownloadSelector.getRootPath,
})

export const consolidatedPortfolioDownloadSelector = getDownloadSelectors({
  getRootPath: selectorsConfig.consolidatedPortfolioDownloadSelector.getRootPath,
})

export const consolidatedPortfolioSelector = getSelectors({
  getRootPath: selectorsConfig.consolidatedPortfolioSelector.getRootPath,
})

export const globalPositionSelector = getSelectors({
  getRootPath: selectorsConfig.globalPositionSelector.getRootPath,
})

export const globalPositionPageSelector = createSelector(
  [globalPositionSelector.isInitialLoadingSelector, globalPositionSelector.payloadSelector],
  (isLoading, globalPositionData) => ({
    isLoading,
    globalPositionData,
    hasExternalProducts: !!globalPositionData?.data?.details?.otherProducts?.items?.some((item) =>
      item.type?.startsWith('OTHER_PRODUCT_'),
    ),
  }),
)
